module.exports = __webpack_public_path__ + "img/img6.408471af.png";